import * as React from "react";
const SvgPlusCircle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#99A0AE", d: "M10.5 17.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m-.75-8.25h-3v1.5h3v3h1.5v-3h3v-1.5h-3v-3h-1.5z" }));
export default SvgPlusCircle;
